<img src="assets/syngovia/icons/empty_state.svg" alt="Empty state icon" />
<div class="messages">
  <sh-text size="header-2">
    {{ 'syngovia.message.dataNotFound' | translate }}
  </sh-text>
  <sh-text size="body-1">
    {{ 'syngovia.message.dataNotFoundDetailed' | translate }}
  </sh-text>
</div>
